module.exports = __webpack_public_path__ + "static/media/citizen-logo.76864281.png";